export default function FlowConnector() {
  return <div className="w-0.5 h-8 bg-ink/30 mx-auto" />;
}
